import React from 'react';
import { GlobalInputProps } from '../../models';
import styles from './inputText.module.scss';
import IconsColor from '../../util/iconsColor';
const InputText: React.FC<GlobalInputProps> = ({
  label,
  value,
  onChange,
  onKeyDown,
  onBlur,
  placeholder = '',
  type = 'text',
  disabled = false,
  required = false,
  error,
  warning,
  width = '100%',
  height = '44px',
  name,
  id,
  autoComplete,
  leftIcon,
  rightIcon,
  onRightIconClick,
  rightIconAriaLabel,
  hideLabel = false,
  noMargin = false,
  maxLength,
  sx
}) => {
  const inputId = id || `input-${label.toLowerCase().replace(/\s+/g, '-')}`;
  const hasLeftIcon = !!leftIcon;
  const hasRightIcon = !!rightIcon;


  return (
    <div
      className={styles.inputWrapper}
      style={{ width, marginBottom: noMargin ? 0 : undefined }}
    >
      {!hideLabel && (
        <label htmlFor={inputId} className={styles.inputLabel}>
          {label}{required && <span className={styles.requiredIndicator}>*</span>}
        </label>
      )}

      <div className={styles.inputContainer}>
        {leftIcon && (
          <div className={styles.inputIcon + ' ' + styles.inputIconLeft}>
            {leftIcon}
          </div>
        )}

        <input
          type={type}
          id={inputId}
          name={name || inputId}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          autoComplete={autoComplete}
          maxLength={maxLength}
          className={styles.inputField + ' ' + (error ? styles.error : '') + ' ' + (warning ? styles.warning : '') + ' ' + (disabled ? styles.disabled : '')}
          style={{
            height,
            paddingLeft: hasLeftIcon ? '48px' : '16px',
            paddingRight: hasRightIcon ? '48px' : '16px',
            ...sx
          }}
        />

        {hasRightIcon && (
          <button
            type="button"
            className={styles.inputIcon + ' ' + styles.inputIconRight}
            onClick={onRightIconClick}
            aria-label={rightIconAriaLabel}
            tabIndex={onRightIconClick ? 0 : -1}
          >
            {rightIcon}
          </button>
        )}
      </div>

      {error && (
        <span className={styles.message + ' ' + styles.errorMessage}>
          <IconsColor
            iconName="errorIcon"
            width="16px"
            height="16px"
            fillColor="none"
            strokeColor="currentColor"
          />
          {error}
        </span>
      )}

      {warning && !error && (
        <span className={styles.message + ' ' + styles.warningMessage}>
          <IconsColor
            iconName="warningIcon"
            width="16px"
            height="16px"
            fillColor="none"
            strokeColor="currentColor"
          />
          {warning}
        </span>
      )}
    </div>
  );
};

export default InputText;
